import { ProductInfo } from "@insite/client-framework/Common/ProductInfo";
import { CartLineModel, ProductInventoryDto, ProductModel, WarehouseDto } from "@insite/client-framework/Types/ApiModels";

export const isHazardousProduct = (cartLine: CartLineModel): "Yes" | "" => {
    return cartLine?.properties?.isHazardousGood === "TRUE" ? "Yes" : "";
};

export const getVendorStockStatus = (product: ProductModel | CartLineModel, productInfo: ProductInfo, productInventoryDtos?: ProductInventoryDto[]): { vendorStockQty: number, vendorStockStatus: string } => {
    let vendorStockQty = 0;
    let vendorStockStatus = "";
    if (productInfo?.inventory?.inventoryWarehousesDtos) {
        const warehouseDto = productInfo.inventory.inventoryWarehousesDtos[0]?.warehouseDtos;
        if (warehouseDto) {
            for (const warehouseData of warehouseDto) {
                if (warehouseData.name === "Vendor Stock") {
                    // setvendorStockQty(warehouseData.qty);
                    vendorStockQty = warehouseData.qty;
                }
                if (warehouseData.qty > 0 && warehouseData.name === "Blind Ship") {
                    // setVendorStockStatus("blindship");
                    vendorStockStatus = "blindship";
                    break;
                }
                const isDSFalse = product?.properties?.isDirectShipFromManufacturer?.toLowerCase?.() === "false";
                if (isDSFalse) {
                    if ((warehouseData.qty > 0 && warehouseData.name === "Vendor Stock") || (warehouseData.qty === 0 && warehouseData.name === "Blind Ship")) {
                        // setVendorStockStatus("crossdock");
                        vendorStockStatus = "crossdock";
                        break;
                    }
                }
            }
        }
    }
    if (productInventoryDtos) {
        const warehouseDto: WarehouseDto[] = productInventoryDtos?.[0]?.inventoryWarehousesDtos?.[0]?.warehouseDtos ?? [];
        for (const warehouseData of warehouseDto) {
            if (warehouseData.name === "Vendor Stock") {
                vendorStockQty = warehouseData.qty;
            }
            if (warehouseData.qty > 0 && warehouseData.name === "Blind Ship") {
                vendorStockStatus = "blindship";
                break;
            }
            const isDSFalse = product?.properties?.isDirectShipFromManufacturer?.toLowerCase?.() === "false";
            if (isDSFalse) {
                if ((warehouseData.qty > 0 && warehouseData.name === "Vendor Stock") || (warehouseData.qty === 0 && warehouseData.name === "Blind Ship")) {
                    vendorStockStatus = "crossdock";
                    break;
                }
            }
        }
    }
    if (product?.properties?.isDirectShipFromManufacturer?.toLowerCase?.() === "true" && vendorStockStatus === "") {
        vendorStockStatus = "directship";
    }
    return { vendorStockQty, vendorStockStatus };
}